import { Box } from "theme-ui";

export default function ChevronDownIcon(props) {
  return (
    <Box
      as="svg"
      width="26"
      height="15"
      viewBox="0 0 26 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1L13 13L25 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Box>
  );
}
